export function capitalizeString(s: string): string {
  return s.replace(/^\w/, (c) => c.toUpperCase());
}
